import { boolean, defineAction, number, object, string } from '~/prix'
import geographicalContainment from './geographicalContainment.action.json'

const geographicalContainmentDefinition = defineAction({
  ...geographicalContainment,
  input: object({
    containerLayerSpace: object({
      delimitationType: string(),
      delimitationId: number(),
      delimitationTitle: string(),
    }),
    containedLayerSpace: object({
      delimitationType: string(),
      delimitationId: number(),
      delimitationTitle: string(),
    }),
  }),
  output: object({
    isContained: boolean(),
  }),
})

export default geographicalContainmentDefinition
